import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, Observable, switchMap, take, tap } from 'rxjs';
import { UserRole } from '../models/user.model';
import * as ProfileActions from '../stores/profile/profile.actions';
import { selectProfileState } from '../stores/profile/profile.selector';
import { LoadingState } from '../stores/store.states';

@Injectable({ providedIn: 'root' })
export class LicenseAssignmentGuard implements CanActivate {
  private readonly store = inject(Store);
  private readonly router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.store.select(selectProfileState).pipe(
      take(1),
      tap((profile) => {
        if (profile.quantumProfileLoadingState === LoadingState.FUTURE) {
          this.store.dispatch(ProfileActions.loadingProfile());
        }
      }),
      switchMap(() => this.store.select(selectProfileState)),
      filter(
        (profile) =>
          profile.quantumProfileLoadingState === LoadingState.SUCCESS ||
          profile.quantumProfileLoadingState === LoadingState.ERROR,
      ),
      take(1),
      map((profile) => {
        if (profile.isMasteradmin || profile.role === UserRole.ADMIN) {
          return true;
        }

        const batchId = route.paramMap.get('id');
        const base = state.url.includes('/admin/')
          ? '/admin/licenses/batches'
          : '/licenses/batches';
        return this.router.createUrlTree(batchId ? [base, batchId] : [base]);
      }),
    );
  }
}
